<form [formGroup]="form" (submit)="submit()" a11yFocusTrap a11yAutoFocus>
    <vwui-modal-header>
        <h2 a11yPageTitleLevel="2">{{ 'COPY_PROJECT_ANALYSIS_MODAL.title' | translate }}</h2>
    </vwui-modal-header>
    <vwui-modal-body>
        <p>{{ 'COPY_PROJECT_ANALYSIS_MODAL.description' | translate }}</p>

        <vwui-form-group
            label="{{ 'COPY_PROJECT_ANALYSIS_MODAL.source_project_type' | translate }}"
            inputId="sourceProjectTypeId"
        >
            <ng-select [items]="availableProjectTypes()"
                       [selectOnTab]="true"
                       bindLabel="name"
                       bindValue="id"
                       labelForId="sourceProjectTypeId"
                       placeholder="{{ 'COPY_PROJECT_ANALYSIS_MODAL.placeholder.project_type' | translate }}"
                       formControlName="sourceProjectTypeId"
            >
            </ng-select>
        </vwui-form-group>

        <vwui-form-group
            label="{{ 'COPY_PROJECT_ANALYSIS_MODAL.source_version' | translate }}"
            inputId="sourceVersionId"
        >
            <ng-select [selectOnTab]="true"
                       labelForId="sourceVersionId"
                       [loading]="isLoadingVersions()"
                       placeholder="{{ (isLoadingVersions() ? 'COPY_PROJECT_ANALYSIS_MODAL.placeholder.loading' : 'COPY_PROJECT_ANALYSIS_MODAL.placeholder.version') | translate }}"
                       formControlName="sourceVersionId"
            >
                @for (version of availableVersions(); track version.id) {
                    <ng-option [value]="version.versionId">
                        v{{ version.versionId }} · {{ 'PAGE_PROJECT_TYPE.versions.status.' + version.status | translate }}
                    </ng-option>
                }
            </ng-select>
        </vwui-form-group>
    </vwui-modal-body>
    <vwui-modal-footer>
        <vwui-button class="is-light" (click)="modalRef.close()">
            {{ 'BUTTON.cancel' | translate }}
        </vwui-button>
        <vwui-button class="is-primary" (click)="submit()" [disabled]="!form.valid">
            {{ 'COPY_PROJECT_ANALYSIS_MODAL.confirm' | translate }}
        </vwui-button>
    </vwui-modal-footer>
</form>
